export const getMediaUrl = image => {
  if (!image) {
    return null
  }

  if (image.imageFile && image.imageFile.publicURL) {
    return image.imageFile.publicURL
  }

  if (image.sourceUrl) {
    return image.sourceUrl
  }

  if (image.mediaItemUrl) {
    return image.mediaItemUrl
  }

  return null
}
